import { Shark, Utils } from "shark-mvc";

import NousCoreModel from "./NousCoreModel";

class OrganizationMembership extends NousCoreModel {
	static ROLE_ADMIN = "admin";
	static ROLE_OWNER = "owner";
	static ROLE_POWER_ADMIN = "powerAdmin";
	static ROLE_POWER_USER = "powerUser";
	static ROLE_USER = "user";

	static STATUS_PENDING = 1;
	static STATUS_ACTIVE = 2;
	static STATUS_REFUSED = 3;
	static STATUS_DISABLED = 4;

	activityColor = "color-0";
	inviteEMail = "";
	inviteMessage = "";
	inviteName = "";
	organizationGuid = "";
	settings = {
		externalCost: 0,
		internalCost: 0,
	};
	role = "";
	userGuid = "";

	__roleEditable = true;
	__roleIcon = "";
	__roleLabel = "";
	__statusEditable = false;
	__statusLabel = "";

	constructor (data) {
		super(data, "OrganizationMembership");
		
		// console.log(data);
		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		// exportData.roles = this.exportArrayField("roles");
		exportData.settings = this.exportObjectField("settings");

		return exportData;
	}

	import (data) {
		super.import(data);
		
		this.parseSenderUser();
		this.parseStatus();
		this.parseUserInvited(); //ALICE: non sa se va bene
		this.parseUserRole();

		// switch (this.role) {
		// 	case OrganizationMembership.ROLE_ADMIN:
		// 		this.__roleLabel = "Admin";
		// 		break;
		// 	case OrganizationMembership.ROLE_OWNER:
		// 		this.__roleLabel = "Owner";
		// 		break;
		// 	case OrganizationMembership.ROLE_POWER_ADMIN:
		// 		this.__roleLabel = "Power Admin";
		// 		break;
		// 	case OrganizationMembership.ROLE_POWER_USER:
		// 		this.__roleLabel = "Power User";
		// 		break;
		// 	case OrganizationMembership.ROLE_USER:
		// 		this.__roleLabel = "User";
		// 		break;
		// }
	}

	onActivityColorChanged () {
		Shark.render();
	}

	onStatusChanged () {
		this.parseStatus();
	}

	onRoleChanged () {
		this.parseUserRole();
	}

	parseSenderUser () {
		const sender = Utils.safp(Shark.$store.userList, "guid", this.createdByGuid);
		// console.log(sender);
		
		if (sender) {
			this.__senderUser = sender;
		}
	}

	parseUserInvited () {
		const invitedUser = Utils.safp(Shark.$store.userList, "email", this.inviteEMail);

		if (invitedUser) {
			// console.log(invitedUser);
			this.__invitedUser = invitedUser;
		}	
	}

	parseUserRole () {
		if (this.role === OrganizationMembership.ROLE_OWNER) {
			this.__roleEditable = false;
		}

		const userRoleObj = Shark.$store.userRoleMap.find(item => item.id === this.role);

		if (userRoleObj) {
			this.set({
				__roleIcon: userRoleObj.icon,
				__roleLabel: userRoleObj.label,
			});
			
			this.clean(["__roleIcon", "__roleLabel"]);

			// Dave: Questo render è "bruttino", perché lo devo chiedere io, ma risolve anche il cambio dell'icona... Andrebbe reso default di Shark..
			Shark.render();
		}
	}

	parseStatus () {
		switch (this.status) {
			case OrganizationMembership.STATUS_ACTIVE:
				this.__statusLabel = Shark.$store.labels.status_active;
				this.__statusEditable = true;
				break;
			case OrganizationMembership.STATUS_DISABLED:
				this.__statusLabel = Shark.$store.labels.status_disabled;
				this.__statusEditable = true;
				break;
			case OrganizationMembership.STATUS_PENDING:
				this.__statusLabel = Shark.$store.labels.status_pending;
				break;
			case OrganizationMembership.STATUS_REFUSED:
				this.__statusLabel = Shark.$store.labels.status_refused;
				break;
		}
	}

	validate () {
		let errors = [];

		errors = errors.concat(this.validateEmail());
		errors = errors.concat(this.validateMemberName());
		errors = errors.concat(this.validateOrganizationGuid());
		errors = errors.concat(this.validateRole());

		return errors;
	}

	validateEmail () {
		let error = [];
		if (this.inviteEMail.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_insert_member_email_name,
				field: "inviteEMail",
			});
		}
		return error;
	}

	validateMemberName () {
		let error = [];
		if (this.inviteName.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_insert_member_name,
				field: "inviteName",
			});
		}
		return error;
	}
	
	validateRole () {
		let error = [];
		if (this.role.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_select_member_role_name,
				field: "role",
			});
		}
		return error;
	}

	// validateMemberName () {
	// 	let error = [];
	// 	if (this.inviteName.trim() === "") {
	// 		error.push({
	// 			error: Shark.$store.labels.errors.you_must_insert_member_name,
	// 			field: "inviteName",
	// 		});
	// 	}
	// 	return error;
	// }

	validateOrganizationGuid () {
		let error = [];
		if (this.organizationGuid.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_select_an_organization,
				field: "organizationGuid",
			});
		}
		return error;
	}
}

Shark.registerModel("OrganizationMembership", OrganizationMembership);

export default OrganizationMembership;
